import { gql } from '@apollo/client'

export const FRAGMENT_PLAN = gql`
  fragment FragmentPlan on Plan {
    jobPins
    jobPinnedCreators
    jobPinnedPosts
    jobPinnedSubtopics
    jobPinnedTopics
    jobPinnedSavedSearches
    jobFolders
    jobs
    workspaces
    editors
    viewers
  }
`
